<template>
  <v-row justify="center">
     <v-btn class="btn-report-activity btn-color"
        fab
        small
        @click.stop="(dialog=true, mounted())"
      >
      <v-icon dark> mdi-account </v-icon>
      </v-btn>
    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card style="border-radius: 0px;">
        <!-- <v-toolbar dark color="primary"  style="justify-content: flex-end;display: flex;height: 56px !important;">
          <v-toolbar-items>
            <v-btn dark text @click="dialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar> -->
        <v-list
          three-line
          subheader
        >
          <div style="display: flex;  justify-content: space-between;">
            <div style="margin: 10px 20px;font-size: 17px;font-weight: bold;">
              <v-btn icon @click="dialog = false">
                  <v-icon  class="mr-2" style="padding-bottom: 1px;">mdi-chevron-left</v-icon>
                </v-btn>
                <span>ย้อนกลับ</span>
            </div>
            <v-btn v-if="dataReady" class="export-btn btn-color mr-5" outlined color="indigo">
              <v-icon left color="indigo">mdi-download</v-icon>
              <download-excel
                class="btn btn-default indigo--text"
                :data="export_data"
                :fields="typeActivity === 'คำตอบแบบ 1 ตัวเลือก' || this.typeActivity === 'คำตอบแบบมากกว่า 1 ตัวเลือก' ? export_fields2 : export_fields"
                :type="exportType"
                :worksheet="exportWorksheet"
                :name="exportFileName"
              >
                Export Data
              </download-excel>
            </v-btn>
            <!-- <div class="mt-1"><v-btn text @click="dialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn></div> -->
          </div>
            <div style="margin: 300px auto" v-if="!dataReady" class="text-center">
              <v-progress-circular
                indeterminate
                color="primary"
              ></v-progress-circular>
            </div>
          <v-col cols="12">
            <div class="pa-5 mt-4 mb-4" style="background-color: #cdcdcd;" v-if="form1.length > 0">
            {{this.form1[0].title}}
            </div>
            <v-card elevation="7" v-if="dataReady">
              <v-card-title>
                <v-text-field
                  v-model="searchAll2"
                  append-icon="mdi-magnify"
                  label="Search"
                  single-line
                  hide-details
                  dense
                ></v-text-field>
              </v-card-title>
              <v-card-text>
                <v-data-table
                  :headers="columns"
                  :items="form1"
                  :search="searchAll2"
                  :items-per-page="10"
                  dense
                >
                 <template v-slot:[`item.picture`]="{ item }">
                      <v-avatar
                        color="primary"
                        size="40"
                      > <img
                          :src="item.picture"
                          alt="img"
                        ></v-avatar>
                  </template>
                  <template v-slot:[`item.startDate`]="{ item }">
                    {{ format_date(item.startDate) }}
                  </template>
                  <template v-slot:[`item.endDate`]="{ item }">
                    {{ format_date(item.endDate) }}
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
          </v-col>

        </v-list>
      </v-card>
    </v-dialog>
    <!-- เพิ่มเติม -->
    <v-dialog v-model="dialogEdit">
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          เพิ่มเติม
        </v-card-title>
          <v-text-field
          v-model="form.field2Value"
          label="ชื่อ"
          placeholder="ชื่อ"
          dense>
          </v-text-field>
          <v-text-field
          v-model="form.field1Value"
          label="เลขที่บัตร"
          placeholder="เลขที่บัตร"
          dense>
          </v-text-field>
          <v-text-field
          v-model="form.lineUserId"
          label="lineUserId"
          placeholder="lineUserId"
          dense>
          </v-text-field>
        <v-divider></v-divider>
      </v-card>
    </v-dialog>
    <!-- เพิ่มเติม -->
  </v-row>
</template>
<script>
// import { defineComponent } from '@vue/composition-api'
import axios from 'axios' // api
import JsonExcel from 'vue-json-excel' // https://www.npmjs.com/package/vue-json-excel
import XLSX from 'xlsx' // import xlsx
import moment from 'moment'

export default ({
  components: {
    downloadExcel: JsonExcel,
    XLSX
  },
  props: ['shopId', 'activityId'],
  data () {
    return {
      dataReady: true,
      title: 'Loyalty',
      test: false,
      dialogEdit: false,
      dialog: false,
      searchAll2: '',
      form: [],
      form1: [],
      exportType: 'xls',
      exportFileName: 'Report_Activity_Member',
      exportWorksheet: 'WorkSheet',
      export_fields: {
        Linename: 'name',
        type: 'type',
        repeat: 'repeats',
        coin: 'coin',
        startDate: 'startDate',
        joinDate: 'joinDate',
        NameCustomer: 'nameCustomer',
        lineUserId: 'lineUserId',
        title: 'title',
        field1Title: 'field1Title',
        field1Value: 'field1Value',
        field2Title: 'field2Title',
        field2Value: 'field2Value',
        field3Title: 'field3Title',
        field3Value: 'field3Value',
        field4Title: 'field4Title',
        field4Value: 'field4Value',
        billingNumber: 'bvpBillingNumber'
      },
      export_fields2: {
        lineUserId: 'lineUserId',
        Linename: 'name',
        type: 'type',
        repeat: 'repeats',
        coin: 'coin',
        startDate: 'startDate',
        joinDate: 'joinDate',
        NameCustomer: 'nameCustomer',
        title: 'title',
        billingNumber: 'bvpBillingNumber'
      },
      typeActivity: null,
      columns: [
        // { text: 'Action', value: 'action', sortable: false, align: 'center' },
        { text: 'รูปโปรไฟล์', value: 'picture' },
        { text: 'ชื่อลูกค้า', value: 'name' },
        { text: 'ประเภท', value: 'type' },
        { text: 'เหรียญ', value: 'coin' },
        {text: 'วันที่เข้าร่วมกิจกรรม', value: 'joinDate', width: '150px'},
        {text: 'BillingNumber', value: 'bvpBillingNumber', width: '150px'},
        {text: 'lineUserId', value: 'lineUserId', width: '150px'}
      ],
      beforeCreate () {
        if (!this.$session.exists()) {
          this.$router.push('/Core/Login')
        }
      },
      async mounted () {
        this.dataReady = false
        this.getData()
        if (this.shopId === 'U4e23f7bf31b362622ff7c5c06dfdf350') {
          this.export_fields2['billingNumber'] = 'bvpBillingNumber'
          this.export_fields['billingNumber'] = 'bvpBillingNumber'
        }
        this.generateFileName()
      },
      generateFileName () {
        const date = moment().format('DDMMYYYY')
        this.exportFileName = `Report_Activity_Member_${date}.xls`
      },
      async getData () {
        await axios.get(this.DNS_IP + '/report-activee/' + 'get?shopId=' + this.shopId + '&activityId=' + this.activityId)
          .then(async (response) => {
            this.form1 = response.data
            this.typeActivity = null
            if (response.data.length > 0) {
              this.typeActivity = response.data[0].answerType
            }
            console.log('typeActivity', this.form1)
            if (this.typeActivity === 'คำตอบแบบ 1 ตัวเลือก' || this.typeActivity === 'คำตอบแบบมากกว่า 1 ตัวเลือก') {
              this.form1.map((a) => {
                a.answerForChoice = JSON.parse(a.answerForChoice)
              })
              this.form1.map((a) => {
                a.answerForChoice.map((item) => {
                  console.log('fff', item)
                  item.map((item2, index) => {
                    item[index] = item2.split('/')[0]
                  })
                })
              })
              console.log('this.form1', this.form1)
              this.form1.map((b, i) => {
                if (b.answerForChoice) {
                  b.answerForChoice.forEach((item, index) => {
                    console.log('index', index)
                    const keyName1 = `exelAnswer${index + 1}`
                    b[keyName1] = b.answerForChoice[index].filter((value2, index2) => index2 > 0).toString()
                    const keyName2 = `${b.answerForChoice[index][0]}`
                    this.export_fields2[keyName2] = `exelAnswer${index + 1}`
                  })
                }
              })
            }
            console.log('this.form12', this.form1)
            console.log('test11', this.export_fields)
            this.export_data = this.form1
            console.log('this.export_data', this.export_data)
            this.export_data.forEach((item) => {
              if (item.field1Title) {
                item.field1Title = JSON.parse(item.field1Title)[0]
              }
              if (item.field2Title) {
                item.field2Title = JSON.parse(item.field2Title)[0]
              }
              if (item.field3Title) {
                item.field3Title = JSON.parse(item.field3Title)[0]
              }
              if (item.field4Title) {
                item.field4Title = JSON.parse(item.field4Title)[0]
              }
            })
            // this.form1.filter(item => item.name !== null)
            if (this.form1.find((item) => item.field1Title === '' && item.field2Title === '')) {
              this.columns = this.columns.filter(item => item.text !== 'ชื่อ' && item.text !== 'เลขที่บัตร' && item.text !== 'Action')
            }
            this.form1 = this.form1.filter(item => item.lineUserId !== null)
            this.dataReady = true
          })
          .catch((error) => {
            console.log(error)
            this.dataReady = true
          })
      },
      async getDataById (item) {
        console.log('item', item)
        this.dataReady = false
        await this.getDataByIdGlobal(this.DNS_IP, '/activity/', 'activityId', item.activityId)
        this.form = item
      }
    }
  }
})
</script>
<style lang="css" scoped>
.export-btn{
  margin-left: 15px;
  margin-top: 10px;
}
.btn-report-activity{
  outline: none;
}
</style>



// WEBPACK FOOTER //
// src/components/ReportActivity/ReportActivityAVG.vue